var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"50px","line-height":"50px","text-align":"center","width":"100%","border":"1px solid #eee","margin-bottom":"10px","border-radius":"5px"}},[_vm._v("\n  暂无数据\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }